module.exports = __webpack_public_path__ + "img/delete02.6cd59790.png";